import { ObjectToURLParamsT } from './types';

export const generateCategoryName = (
  category: string | undefined,
  brand: string | undefined,
) => {
  if (!brand && category) return category;
  if (!category) return 'default';

  const isAppleSmartphone = brand === 'Apple' && category === 'Smartphones';
  const isSamsungSmartphone = brand === 'Samsung' && category === 'Smartphones';
  const isAppleLaptop = brand === 'Apple' && category === 'Laptops';

  if (isAppleSmartphone) return 'Smartphones/Apple';
  if (isSamsungSmartphone) return 'Smartphones/Samsung';
  if (isAppleLaptop) return 'Laptops/MacBooks';

  return category;
};

export function objectToUrlParams(obj: ObjectToURLParamsT) {
  return Object.entries(obj)
    .filter(([, value]) => value !== undefined) // Filter out undefined values
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`,
    )
    .join('&');
}
